export const vaultTradeMap = {
  VAULT_DEPOSIT: t('Deposit'),
  VAULT_WITHDRAW: t('Withdraw'),
};
export const currencyTypeMap = {
  0: t('Fiat'),
  1: t('Crypto'),
};
